export const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    dense: {
        marginTop: 19,
    },
    menu: {
        width: 300,
    },
    paper: {
        position: 'absolute',
        width: "200px",
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        outline: 'none',
    },
});

export const GENDERS = [
    {
        value: 'male',
        label: 'Male',
    },
    {
        value: 'female',
        label: 'Female',
    },
];

export const COLOURS = [
    {
        value: 'red',
        label: 'Red Monster',
    },
    {
        value: 'green',
        label: 'Green Hero',
    },
    {
        value: 'blue',
        label: 'Blue Robot',
    },
];

export const SIZES = [
    {
        value: 'xs',
        label: 'ADULT XS',
    },
    {
        value: 's',
        label: 'ADULT S',
    },
    {
        value: 'm',
        label: 'ADULT M',
    },
    {
        value: 'l',
        label: 'ADULT L',
    },
    {
        value: 'xl',
        label: 'ADULT XL',
    },
    {
        value: 'xxl',
        label: 'ADULT XXL',
    },
];